jQuery(document).ready(function($){
	
	
	
	//Remove no-js helper class if js available
	$('.no-js').removeClass('no-js');
	
	
	
	/* Mobile Menu */
	$('.nav_btn-toggle').click(function(){
		
		var parentEl = $(this).parent();		
		$('.nav_menu', parentEl).slideToggle(400);
		
	});
	
	
	
	/* Slick Slider Settings*/
	$('.slider').slick({
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5000,
		prevArrow: '<a class="slick-prev"><i class="fa fa-angle-left"></i></a>',
		nextArrow: '<a class="slick-next"><i class="fa fa-angle-right"></i></a>',
	});
	
	
		/*Animate Hero Content*/
		$('.hero_section-content').css({
			'left' : '-50%',
			'opacity' : 0
		}
		).delay(
			600
		).animate({ 
			opacity: 1, 
			left: 0
		}, {
			duration: 600, 
			specialEasing: { 
			opacity: 'linear',
			left: 'linear'
		}, 
		complete: function(){

		}			
		});//end1



});










